import React, { useState } from 'react';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../context/EndorsementProvider';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import EndorsementActions from '../policy/Actions/EndorsementActions';
import Breadcrumbs from '../policy/Endorsements/Breadcrumbs';
import Overview from '../policy/Endorsements/Overview';

interface Props {
	children?: JSX.Element | JSX.Element[];
	endorsementData: EndorsementData;
}

const EndorsementLayout = (props: Props) => {
	const [loading, setLoading] = useState<boolean>(false);
	props.endorsementData.setLoading = setLoading;

	const renderActions = () => {
		return <EndorsementActions />;
	};

	return (
		<>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				{renderActions()}
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<Overview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withEndorsementContext<Props>(EndorsementLayout);
